import { cn } from '@module/lib/utils';
import toast from 'react-hot-toast';

import BaseButton from '../button/BaseButton';

interface Props {
  id: string;
  content: string;
  onMainButtonClick?: () => void;
  /** 래퍼 정렬 오버라이드용(기본 좌우 분리 레이아웃을 덮어쓸 때만 전달) */
  className?: string;
  /** 문구 영역 오버라이드용 — 가운데 정렬·줄바꿈 유지 등 */
  contentClassName?: string;
}

function ToastBody({ id, content, onMainButtonClick, className, contentClassName }: Props) {
  return (
    <div
      className={cn(
        'flex w-full items-center justify-between rounded-[6px] bg-colorBg_snackbar px-[16px] py-[12px] text-colorFg05',
        className,
      )}
    >
      <div className={cn('pr-3 text-[15px]', contentClassName)}>
        <span className='break-all'>{content}</span>
      </div>
      {onMainButtonClick && id && (
        <div className='flex items-center'>
          <BaseButton
            type='button'
            variant='ghost'
            size='none'
            className='pl-[24px] text-center text-[16px] text-white'
            onClick={() => {
              onMainButtonClick();
              toast.dismiss(id);
            }}
          >
            {'확인'}
          </BaseButton>
        </div>
      )}
    </div>
  );
}

export default ToastBody;
